module.exports = __webpack_public_path__ + "assets/img/f2.1040f663.png";